import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import config from 'configs/app';
import SeoListPageShell from 'ui/shared/seo/SeoListPageShell';

const Transactions = dynamic(() => import('ui/pages/Transactions'), { ssr: false });

const Page: NextPage = () => {
  const title = config.meta.seo.enhancedDataEnabled ?
    `${ config.chain.name } transactions` :
    'Transactions';

  return (
    <SeoListPageShell pathname="/txs" title={ title }>
      <Transactions hideTitle/>
    </SeoListPageShell>
  );
};

export default Page;
